module.exports = __webpack_public_path__ + "img/intro-img.0d4abf3d.png";